import React from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import IconKeyboardArrowRight from '@aboutbits/react-material-icons/dist/IconKeyboardArrowRight'
import {
  Section,
  SectionItem,
  SectionList,
  SectionTitle,
} from '../../../shared/section'
import { useGetAddressById } from '../../address/db/addresses'
import { getAddressLink } from '../../address/utils'

const ReferencedAddress: React.FC<{
  id: string
}> = ({ id }) => {
  const { data: address } = useGetAddressById(id)
  const link = getAddressLink(id)

  return address ? (
    <Section>
      <SectionTitle>
        <FormattedMessage
          id="notification.resource.address"
          defaultMessage="Address"
        />
      </SectionTitle>
      <SectionList>
        <Link to={link} className="block">
          <SectionItem>
            <h2 className="flex-1">{address.name}</h2>
            <IconKeyboardArrowRight className="size-6" />
          </SectionItem>
        </Link>
      </SectionList>
    </Section>
  ) : null
}

export { ReferencedAddress }
